import { useState } from 'react';

import { navigateToMarketingSite } from '../../utils/navigator';
import { StringAvatar } from '../../components/Avatar';
import LogoutDialog from '../../components/Logout';
import SimplePlanLogo from '../../images/simple-plan-logo-white.svg';
import useAuth from '../../context/AuthContext';
import { DOMAIN_NAME } from '../../constants/config';

const ONBOARDING_NAVIGATIONS = {
  'Why Simple Plan': '#whysimpleplan',
  'Simplicity for Your Team': '#yourtoolsection',
  Features: '#featuresection',
  'Contact Us': '#contactus',
};

const marketingSiteUrl = (path) => `https://${DOMAIN_NAME}${path}`;

const OnboardingHeader = () => {
  // init
  const { authUser } = useAuth();

  // states
  const [isOpenLogoutDialog, setIsOpenLogoutDialog] = useState(false);

  const handleDialog = () => setIsOpenLogoutDialog(!isOpenLogoutDialog);

  return (
    <header className="onboarding-header">
      <div className="content">
        <a style={{ display: 'flex', alignItems: 'center' }} href={marketingSiteUrl('')}><img src={SimplePlanLogo} alt="Simple Plan Logo" /></a>
        <nav className="nav-links">
          {Object.entries(ONBOARDING_NAVIGATIONS).map(([key, value]) => <a href={marketingSiteUrl(value)} key={key} className="nav-link">{key}</a>)}
          <LogoutDialog handleDialog={handleDialog} openDialog={isOpenLogoutDialog} component={<button type="button" style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }} onClick={handleDialog}><StringAvatar transparentWhiteAvatar initials={1} fontWeight={400} fontSize={22} height={40} width={40} placeHolder="" name={authUser?.firstName ?? authUser?.email ?? ''} /></button>} setOpenDialog={setIsOpenLogoutDialog} onLogoutSuccess={() => navigateToMarketingSite()} />
        </nav>
      </div>
    </header>
  );
};

export default OnboardingHeader;
